@if(Settings.isInAny(['BackOffice']) && !isCustomerSpecific) {
  <t4-header icon="glyphicon-stats" title="{{ 'TO.Invoices.Headline' | translate : 'Invoices' }}">
  </t4-header>
}
<t4-container [isLoading]="isLoading">
  <h2 *ngIf="isLoading">{{ 'TO.Invoices.lbProcessingServer' | translate : 'Please wait while querying database (this may take a few minutes)' }}...</h2>
  <t4-periodPicker period="month" [(from)]="from" [(to)]="to" (periodChanged)="updateParams()"></t4-periodPicker>
  <t4-container title="{{ 'TO.Invoices.lblFilter' | translate : 'Filter'}}">
    @if(!isCustomerSpecific) {
    <div>
      <mat-form-field appearance="outline" style="max-width: 400px;">
        <mat-label>{{ 'TO.Invoices.lblCustomer' | translate : 'Customer' }}</mat-label>
        <mat-select [(ngModel)]="selectedCustomer" (ngModelChange)="onCustomerChange($event)" panelClass="customer-panel" (openedChange)="resetSearch($event)">
          <div class="search-container" style="position: sticky; top: 0; z-index: 1; background: white; width: 100%; padding-top: 2px;">
            <mat-form-field appearance="outline" style="width: 100%;">
              <input matInput [(ngModel)]="searchText" (keyup)="filterCustomers()" placeholder="{{ 'TO.Invoices.lblSearchCustomer' | translate:'Type to search...' }}"
                     (click)="$event.stopPropagation()" />
            </mat-form-field>
          </div>
          <mat-option [value]="0">{{ 'TO.Invoices.lblAllCustomers' | translate : 'All Customers' }}</mat-option>
          <mat-option *ngFor="let customer of filteredCustomers" [value]="customer.InvoiceAccount">{{customer.Name}}({{ customer.InvoiceAccount }})</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    }
    <div>
      <mat-form-field appearance="outline" style="max-width: 400px;">
        <mat-label>{{ 'TO.Invoices.lblProduct' | translate : 'Product' }}</mat-label>
        <mat-select [(ngModel)]="selectedProduct" (ngModelChange)="onProductChange($event)" panelClass="product-panel" (openedChange)="resetProductSearch($event)">
          <div class="search-container" style="position: sticky; top: 0; z-index: 1; background: white; width: 100%; padding-top: 2px;">
            <mat-form-field appearance="outline" style="width: 100%;">
              <input matInput [(ngModel)]="searchProductText" (keyup)="filterProducts()" placeholder="{{ 'TO.Invoices.lblSearchCustomer' | translate:'Type to search...' }}"
                     (click)="$event.stopPropagation()" />
            </mat-form-field>
          </div>
          <mat-option [value]="0">{{ 'TO.Invoices.lblAllProducts' | translate : 'All Products' }}</mat-option>
          <mat-option *ngFor="let product of filteredProducts" [value]="product.Id">{{product.Name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </t4-container>

  <t4-data-table #tblInvoices [rawData]="filteredInvoices" matSortActive="GeneratedAt" matSortDirection="desc" headline="{{ 'TO.Invoices.InvoicesHeadline' | translate : 'Invoices' }}" [autoGenerateColumns]="false" matSort [filterFields]="['InvoiceAccount', 'CustomerName', 'CustomerNumber', 'Flow', 'SalesId', 'MessageId']">
    <ng-container matColumnDef="Id">
      <mat-header-cell *matHeaderCellDef style="max-width: 60px;"></mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width: 60px;" (click)="open(row.Id)">
        @if(!row.SalesId && !row.IsProcessing) {
        <mat-icon style="color: red;" matTooltip="'TO.Invoices.Pending' | translate : 'Pending'">block</mat-icon>
        }
        @else if(row.SalesId || row.IsProcessing) {
        <mat-icon matTooltip="'TO.Invoices.Sent' | translate : 'Sent'">receipt</mat-icon>
        }
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="SalesId">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 100px">{{ 'TO.Invoices.lblSalesIdt' |translate : 'Sales Id' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="width: 100px">{{ row.SalesId }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="CustomerName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.Invoices.lblCustomerName' |translate : 'Customer Name' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.CustomerName }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="CustomerNumber">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.Invoices.lblCustomerNumber' |translate : 'Customer Number' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.CustomerNumber }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="InvoiceAccount">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.Invoices.lblInvoiceAccount' |translate : 'Invoice Account' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.InvoiceAccount }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="Flow">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.Invoices.lblFlow' |translate : 'Flow' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.Flow }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="LineCount">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 50px">{{ 'TO.Invoices.lblLineCount' |translate : 'Lines' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="width: 50px">{{ row.LineCount }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="InvoiceAmount">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 100px">{{ 'TO.Invoices.lblInvoiceAmount' |translate : 'Amount' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="width: 100px">{{ row.InvoiceAmount | currency }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="VatAmount">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 100px">{{ 'TO.Invoices.lblVatAmount' |translate : 'Vat' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="width: 100px">{{ row.VatAmount | currency }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="GeneratedAt">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 125px;">{{ 'TO.Invoices.lblGenerated' |translate : 'Created' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width: 125px;">{{ row.GeneratedAt | date : 'yyyy-MM-dd HH:mm' }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="CompletedAt">
      <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 125px">{{ 'TO.Invoices.lblCompletedAt' |translate : 'Processed' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="width: 125px">{{ row.CompletedAt | date : 'yyyy-MM-dd HH:mm' }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="MessageId">
      <mat-header-cell *matHeaderCellDef style="max-width: 150px;">{{ 'TO.Invoices.lblResendInvoice' |translate : 'Resend Invoice' }}</mat-header-cell>
      <mat-cell *matCellDef="let row" style="max-width: 150px;">
        @if(!row.SalesId && !row.IsProcessing) {
        <button mat-icon-button color="primary" (click)="resend(row)">
          <mat-icon>send</mat-icon>
        </button>
        }
      </mat-cell>
    </ng-container>
  </t4-data-table>
</t4-container>

